<template>
    <div class="record-view right_auth">
        <div class="time">
            <label>订单时间： </label>
            <sd-select :options="options" :open="open"
                       @changeOpen="open =! open" :value="dateRange" @changeOption="changeRange"></sd-select>
        </div>
        <div v-if="list.length">
            <table>
                <colgroup>
                    <col class="col_3">
                    <col class="col_3">
                    <col class="col_3">
                </colgroup>
                <thead>
                <tr>
                    <td>编号</td>
                    <td>提现时间</td>
                    <td>提现金额</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="li in list">
                    <td>{{li.id}}</td>
                    <td>{{li.createTime | time2}}</td>
                    <td class="red">￥{{li.extractMoney}}</td>
                </tr>
                </tbody>
            </table>
            <div class="page_wrap">
                <sd-pager ref="pager" :page-data="page" @page-change="pageChange"></sd-pager>
            </div>
        </div>
        <div class="g_empty" v-if="!list.length">
            <p class="info">没有相关提现记录~</p>
        </div>
    </div>
</template>
<script>
    import sdSelect from '../components/sdSelect'
    import {util} from '../service/util'
    import { mapState, mapActions , mapGetters} from 'vuex'
    import moment from 'moment'
    import sdPager from '../components/sdPager.vue'
    let API = util.api(['SEARCHCUSTOMEREXTRACT']);
    export default{
        components:{sdSelect,sdPager},
        data(){
            return {
                options:[
                    {
                        label:'全部',
                        param:{

                        }
                    },
                    {
                        label:'近三个月订单',
                        param:{
                            beginTime : moment().subtract(3,'month').format('YYYY-MM-01 HH:mm:ss'),
                            endTime : moment().format('YYYY-MM-DD HH:mm:ss')
                        }
                    },
                    {
                        label:'近六个月订单',
                        param:{
                            beginDate : moment().subtract(6,'month').format('YYYY-MM-01 HH:mm:ss'),
                            endDate : moment().format('YYYY-MM-DD HH:mm:ss')
                        }
                    },
                    {
                        label:'一年前订单',
                        param:{
                            endTime : moment().subtract(1,'year').format('YYYY-MM-DD')
                        }
                    },
                ],
                open:false,
                dateRange: {label: '全部',param:{}},
                list:[],
                page:{
                    pageNo:1,
                    pageSize:15,
                    totalPage:1
                }
            }
        },
        computed:{
            param(){
                return{
                    ...this.dateRange.param,
                    ...this.page
                }
            }
        },
        methods:{
            changeRange(data){
                this.dateRange = data;
                this.open = !this.open;
                this.page = this.$options.data().page;
                this.search();
            },
            pageChange(){
                this.search();
            },
            search(){
                let _this = this;
                util.kAjax(API.SEARCHCUSTOMEREXTRACT,this.param,json=>{
                    _this.list = json.data.datas;
                    this.page.pageNo = json.data.pageNo;
                    this.page.totalPage = json.data.totalPage;
                });
            }
        },
        mounted(){
            this.search();
        }
    }
</script>


// WEBPACK FOOTER //
// WithdrawRecord.vue?86bb7ce2